<template>
    <div>
        <div class="mx-2 card" v-if="hasEditRights && !isNew && canWrite && !isLockedForEdit">
            <div class="card-body p-0">
                <participant :registerId="registerId"
                             :entryId="entryId"
                             :showExtended="true"
                             :showBankAccount="true"
                             show-en-names
                             @save="participantSave">
                </participant>
            </div>
        </div>
        <div class="m-3" v-if="!isNew">
            <participants-grid ref="participantsGrid"
                               :relatedEventId="Number(entryId)"
                               :showHideButton="false"
                               :showPinButton="false"
                               :showNewButton="false"
                               :showResizeIcon="false"
                               :showSettingsBtn="showSettingsBtn"
                               :showBtns="isLockedForEdit? false:true"
                               :can-write="canWrite"
                               @onEdit="onEdit"
                               @syncWithMoodle="syncWithMoodle">
            </participants-grid>

            <br />
            <div class="alert alert-info" role="alert">
                <h5>{{ $t('certificates.help')}}</h5>
            </div>
        </div>

    </div>

</template>

<script>
    import ParticipantsGrid from '@/components/participants/ParticipantsForEventGrid';
    import Participant from '@/components/participants/Participant';

    export default {
        name: 'participants-management',
        components: {
            ParticipantsGrid,
            Participant
        },
        created: function () {

        },
        props: {
            registerId: {
                type: [Number, String],
                required: true
            },
            entryId: {
                type: [Number, String]
            },
            canWrite: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            showSettingsBtn: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                participantsImporting: false,
                participantsExporting: false
            }
        },
        methods: {
            participantSave(participant) {
                this.$emit('participantsImported');
            },
            refreshParticipantsGrid() {
                const grid = this.$refs.participantsGrid;
                if (grid) {
                    grid.refresh();
                }
            },
            syncWithMoodle(id) {
                this.refreshParticipantsGrid();
            },
            onEdit() {
                this.$emit('onEdit');
            }
        },
        mounted() {

        },
        computed: {
            isNew() {
                return this.entryId === undefined;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            hasEditRights() {
                return true;
            },
        }
    }
</script>


<style>
</style>
